import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { useAsync } from "../lib/useAsync";
import type { MeetListItem } from "../api/types";

function MeetCard({ m }: { m: MeetListItem }) {
  return (
    <div className="card">
      <div className="row spread">
        <Link to={`/meets/${m.meetId}`}>
          <strong>{m.title}</strong>
        </Link>
        {m.status === "cancelled" && (
          <span className="badge cancelled">cancelled</span>
        )}
      </div>
      <p className="muted">
        {new Date(m.startAt).toLocaleString()} · {m.venueName}
        {typeof m.distanceMiles === "number" && ` · ${m.distanceMiles} mi`}
      </p>
      <div className="row">
        <span className="badge going">Going {m.rsvpCounts.going}</span>
        <span className="badge">Maybe {m.rsvpCounts.maybe}</span>
        {m.myRsvp && <span className="muted">You: {m.myRsvp}</span>}
      </div>
    </div>
  );
}

export function Meets() {
  const [scope, setScope] = useState<"mine" | "public">("mine");
  const [sort, setSort] = useState<"date" | "distance">("date");
  const [radius, setRadius] = useState<string>("");
  const [q, setQ] = useState("");

  const { data, loading, error } = useAsync(
    () =>
      api.listMeets({
        scope,
        sort,
        radius: radius ? Number(radius) : undefined,
        q: q || undefined,
      }),
    [scope, sort, radius, q],
  );

  return (
    <div>
      <div className="row spread">
        <h1>Meets</h1>
        <Link to="/meets/new">
          <button>New meet</button>
        </Link>
      </div>

      <div className="card">
        <div className="row">
          <select
            style={{ width: "auto" }}
            value={scope}
            onChange={(e) => setScope(e.target.value as "mine" | "public")}
          >
            <option value="mine">My teams</option>
            <option value="public">Discover public</option>
          </select>
          <select
            style={{ width: "auto" }}
            value={sort}
            onChange={(e) => setSort(e.target.value as "date" | "distance")}
          >
            <option value="date">Sort: Date</option>
            <option value="distance">Sort: Nearest</option>
          </select>
          <select
            style={{ width: "auto" }}
            value={radius}
            onChange={(e) => setRadius(e.target.value)}
          >
            <option value="">Any distance</option>
            <option value="25">Within 25 mi</option>
            <option value="50">Within 50 mi</option>
            <option value="100">Within 100 mi</option>
          </select>
        </div>
        <input
          style={{ marginTop: "0.5rem" }}
          placeholder="Search title / venue / team"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {loading && <p>Loading…</p>}
      {error && <p className="error">{error}</p>}
      {(() => {
        const visible = (data?.items ?? []).filter(
          (m) => m.status !== "cancelled",
        );
        return (
          <>
            {visible.map((m) => (
              <MeetCard key={m.meetId} m={m} />
            ))}
            {data && visible.length === 0 && (
              <p className="muted">No meets match your filters.</p>
            )}
          </>
        );
      })()}
    </div>
  );
}
